jQuery(document).ready( function() {
jQuery( window ).load(function() {
  /*
  jQuery('.grid').isotope({
    itemSelector: '.grid-item',
     masonry: { columnWidth: $container.width() / 2 } 
  });
  */
  jQuery('.grid').masonry({
  // options...
  	itemSelector: '.grid-item',
     columnWidth: '.grid-sizer',
  percentPosition: true,
    isAnimated: true,
  animationOptions: {
    duration: 750,
    easing: 'linear',
    queue: false
  }
  });
  
  	lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    })
});
  });
